export const TicketType = {
    CUSTOMER: 'customer',
    AGENT: 'agent',
    REMARK: 'remark',
    TEXTMSG: 'textMsg',
    CALL: 'call',
    EMAIL: 'email',
    CHANGERECORD: 'changeLogs',
};
